import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const CSRF_COOKIE = 'sso_csrf';
const CSRF_HEADER = 'X-CSRF-Token';

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (req.method === 'GET' || req.method === 'HEAD') return next.handle(req);
    if (!req.url.includes('/sso/')) return next.handle(req);
    const csrf = readCookie(CSRF_COOKIE);
    if (!csrf) return next.handle(req);
    return next.handle(
      req.clone({ setHeaders: { [CSRF_HEADER]: csrf } }),
    );
  }
}

function readCookie(name: string): string | undefined {
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${escaped}=([^;]+)`),
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}
